import React from 'react'

import { Switch } from '@st-operations/uikit/src/v2/index.js'
import { BE_SOCIAL_CHANNELS } from './constants/slidesSchema'

const SocialChannelsSelector = ({ onSocialChannelsChange, selectedChannels }) => {
  const channels = Object.entries(BE_SOCIAL_CHANNELS).map(([key, value]) => ({ key, value }))

  const handleSelect = (channel, wasChecked) => () => {
    if (wasChecked) {
      // remove
      onSocialChannelsChange(selectedChannels.filter((selected) => selected !== channel))
    } else {
      // add
      onSocialChannelsChange([...selectedChannels, channel])
    }
  }

  return (
    <>
      <p className="selected-entities-editor__title">Select Channels</p>
      <For each="channel" index="index" of={channels}>
        <div className="selected-entities-editor__manage-events" key={index}>
          <span>{channel.value}</span>
          <Switch
            checked={selectedChannels.includes(channel.key.toLowerCase())}
            name={channel.key}
            onChange={handleSelect(
              channel.key.toLowerCase(),
              selectedChannels.includes(channel.key.toLowerCase())
            )}
          />
        </div>
      </For>
    </>
  )
}

export default SocialChannelsSelector
